<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    scrollable
    persistent
  >
    <v-card
      :loading="formProcessing"
    >
      <v-card-title class="font-weight-bold">
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="campaignName"
                  required
                  label="Campaign Name"
                  :error-messages="validation(v$.campaignName, 'Campaign Name')"
                  @input="v$.campaignName.$touch()"
                  @blur="v$.campaignName.$touch()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="cost"
                  type="number"
                  step="0.01"
                  required
                  label="Cost"
                  :error-messages="validation(v$.cost, 'Cost')"
                  @input="v$.cost.$touch()"
                  @blur="v$.cost.$touch()"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="biddableCost"
                  :items="biddableCostOptions"
                  item-title="text"
                  item-value="value"
                  required
                  label="Biddable Cost"
                  :error-messages="validation(v$.biddableCost, 'Biddable Cost')"
                  @input="v$.biddableCost.$touch()"
                  @blur="v$.biddableCost.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="leadProviderId"
                  :items="leadProviders"
                  item-title="text"
                  item-value="value"
                  required
                  label="Lead Provider"
                  :error-messages="validation(v$.leadProviderId, 'Lead Provider')"
                  @update:model-value="v$.leadProviderId.$touch()"
                  @blur="v$.leadProviderId.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="productType"
                  :items="productTypeOptions"
                  item-title="text"
                  item-value="value"
                  required
                  label="Product type"
                  :error-messages="validation(v$.productType, 'Product type')"
                  @input="v$.productType.$touch()"
                  @blur="v$.productType.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="6"
              >
                <v-select
                  v-model="onfidoEnabled"
                  :items="enabledOptions"
                  item-title="text"
                  item-value="value"
                  required
                  label="Onfido Enabled"
                  :error-messages="validation(v$.onfidoEnabled, 'Onfido Enabled')"
                  @input="v$.onfidoEnabled.$touch()"
                  @blur="v$.onfidoEnabled.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="6"
              >
                <v-select
                  v-model="finicityEnabled"
                  :items="enabledOptions"
                  item-title="text"
                  item-value="value"
                  required
                  label="Finicity Enabled"
                  :error-messages="validation(v$.finicityEnabled, 'Finicity Enabled')"
                  @input="v$.finicityEnabled.$touch()"
                  @blur="v$.finicityEnabled.$touch()"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model.number="finicityTriggerTier"
                  :disabled="!finicityEnabled"
                  type="number"
                  required
                  label="Finicity Trigger Tier"
                  :error-messages="validation(v$.finicityTriggerTier, 'Finicity Trigger Tier')"
                  @input="v$.finicityTriggerTier.$touch()"
                  @blur="v$.finicityTriggerTier.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="6"
              >
                <v-select
                  v-model="docusignIdCheck"
                  :items="docusignIdCheckOptions"
                  item-title="text"
                  item-value="value"
                  required
                  label="Docusign ID Check"
                  :error-messages="validation(v$.docusignIdCheck, 'Docusign ID Check')"
                  @input="v$.docusignIdCheck.$touch()"
                  @blur="v$.docusignIdCheck.$touch()"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-select
                  v-model="skipLandingPage"
                  :items="skipLandingPageOptions"
                  item-title="text"
                  item-value="value"
                  required
                  label="Skip Landing Page"
                  :error-messages="validation(v$.skipLandingPage, 'Skip Landing Page')"
                  @input="v$.skipLandingPage.$touch()"
                  @blur="v$.skipLandingPage.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="enabled"
                  :items="enabledOptions"
                  item-title="text"
                  item-value="value"
                  required
                  label="Enabled"
                  :error-messages="validation(v$.enabled, 'Enabled')"
                  @input="v$.enabled.$touch()"
                  @blur="v$.enabled.$touch()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="close()"
        >
          Cancel
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import {
  required,
  requiredIf,
} from '@vuelidate/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          cost: '',
          lead_provider_id: '',
          biddable_cost: 0,
          campaign_name: '',
          product_type: '',
          docusign_id_check: '',
          skip_landing_page: '',
          enabled: '',
          onfido_enabled: '',
          finicity_enabled: false,
          finicity_trigger_tier: 0,
        };
      },
    },
    leadProviders: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      biddableCostOptions: [
        { value: 0, text: 'No' },
        { value: 1, text: 'Yes' },
      ],
      productTypeOptions: [
        { value: 'lineOfCredit', text: 'Line Of Credit' },
        { value: 'installment', text: 'Installment' },
      ],
      docusignIdCheckOptions: [
        { value: true, text: 'true' },
        { value: false, text: 'false' },
      ],
      skipLandingPageOptions: [
        { value: true, text: 'true' },
        { value: false, text: 'false' },
      ],
      enabledOptions: [
        { value: true, text: 'true' },
        { value: false, text: 'false' },
      ],
      leadProviderId: '',
      id: null,
      campaignName: '',
      cost: 0.00,
      biddableCost: 0,
      productType: null,
      formProcessing: false,
      docusignIdCheck: null,
      skipLandingPage: null,
      enabled: null,
      onfidoEnabled: null,
      finicityEnabled: false,
      finicityTriggerTier: 0,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formTitle() {
      return this.isNewItem ? 'Add New Campaign' : 'Edit Campaign';
    },
    isNewItem() {
      return !this.editedItem.id;
    },
  },
  watch: {
    editedItem() {
      this.id = this.editedItem.id;
      this.cost = this.editedItem.cost;
      this.biddableCost = this.editedItem.biddable_cost;
      this.leadProviderId = this.editedItem.lead_provider_id;
      this.campaignName = this.editedItem.campaign_name;
      this.productType = this.editedItem.product_type;
      this.docusignIdCheck = this.editedItem.docusign_id_check;
      this.skipLandingPage = this.editedItem.skip_landing_page;
      this.enabled = this.editedItem.enabled;
      this.onfidoEnabled = this.editedItem.onfido_enabled;
      this.finicityEnabled = this.editedItem.finicity_enabled;
      this.finicityTriggerTier = this.editedItem.finicity_trigger_tier;
    },
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.formProcessing = true;

        let request = '';

        let data = {
          cost: this.cost,
          biddableCost: this.biddableCost,
          leadProviderId: this.leadProviderId,
          campaignName: this.campaignName,
          productType: this.productType,
          docusignIdCheck: this.docusignIdCheck,
          skipLandingPage: this.skipLandingPage,
          enabled: this.enabled,
          onfidoEnabled: this.onfidoEnabled,
          finicityEnabled: this.finicityEnabled,
          finicityTriggerTier: this.finicityTriggerTier,
        };

        if (this.isNewItem) {
          data = {
            ...data,
          };

          request = this.$axios.post('/api/v1/campaign', data);
        } else {
          request = this.$axios.put(`/api/v1/campaign/${this.editedItem.id}`, data);
        }

        request
          .then((res) => {
            this.$emit('item-saved');

            this.setNotification({
              message: `${res.data.campaign_name} has been saved.`,
              color: 'green',
            });
          })
          .catch(() => {
            this.setNotification({
              message: 'There was an error processing your request.',
              color: 'red',
            });
          })
          .then(() => {
            this.formProcessing = false;

            this.close();
          });
      }
    },
    close() {
      this.v$.$reset();

      this.$emit('close-modal');
    },
    validation(field, name) {
      const errors = [];

      if (!field.$dirty) {
        return errors;
      }
      if (field.$error) {
        errors.push(`${name} is Required`);
      }
      if (field.$anyError) {
        errors.push(`${name} is Not Valid`);
      }
      return errors;
    },
  },
  validations: {
    campaignName: { required },
    cost: { required },
    biddableCost: { required },
    leadProviderId: { required },
    productType: { required },
    docusignIdCheck: { required },
    skipLandingPage: { required },
    enabled: { required },
    onfidoEnabled: { required },
    finicityEnabled: { required },
    finicityTriggerTier: {
      required: requiredIf((value, vm) => vm.finicityEnabled),
    },
  },
};
</script>

<style></style>
